export default {
    allowHideAfter: Number,
    animation: Object | Boolean,
    appendTo: String | Object,
    autoHideAfter: Number,
    button: Boolean,
    height: Number | String,
    hideOnClick: Boolean,
    position: Object,
    stacking: String,
    templates: Array,
    width: Number | String,

    // Events
    hide: Function,
    show: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/NotificationProps.js